module.exports = __webpack_public_path__ + "img/zsgg-3.66867795.png";